export default "__VITE_ASSET__BiooPNAp__"